// extracted by mini-css-extract-plugin
export default {"mainContainer":"NoSearchResults_mainContainer__SqsW-","title":"NoSearchResults_title__9opIF"};